import { useEffect, useState } from "react";

import { useContextViews } from "src/Contexts/Views/contextViews";
import {
  AssuredWorkloadOutlinedIcon,
  AttachMoneyIcon,
  AutoAwesomeMosaicIcon,
  BarChartIcon,
  DescriptionIcon,
  FileOpenIcon,
  PercentIcon,
  SensorOccupiedIcon,
  SupervisedUserCircleIcon,
} from "src/Pages/components/Icons/Icons";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { UrlConfig } from "src/shared/Utils/paths";

import { AsideMenuLeft } from "./AsideMenuLeft";
import { BaseMenuAside } from "./componentes/BaseMenuAside";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { alpha, useTheme } from "@mui/material";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";

export const AsideTitle = () => {
  const {
    NavigationControleEmpresa,
    NavigationRelations,
    NavigationProdutores,
    NavigationComissoes,
    NavigationUsuarios,
    NavigationLancamentos,
    NavigationPagamentos,
    NavigationDashboard,
    NavigationReportsInstallments,
    NavigationAniversariantes,
  } = useContextViews();
  const { userPerfil } = useAuthContext();
  const { setOpenAside } = useLayoutMainContext();
  const isProducer = userPerfil?.type_user === "PRODUCER";

  const [open1, setOpen1] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open8, setOpen8] = useState(false);
  const [open9, setOpen9] = useState(false);
  const [open10, setOpen10] = useState(false);

  useEffect(() => {
    if (open1 || open3 || open4 || open5 || open8 || open9 || open10) {
      setOpenAside(true);
    }
  }, [open1, open3, open4, open5, open8, open9, open10]);

  const theme = useTheme();

  const colorPrimary = alpha(theme.palette.text.secondary, 1);

  return (
    <>
      <AsideMenuLeft
        icon={<AutoAwesomeMosaicIcon sx={{ color: colorPrimary }} />}
        title="Inicio"
        to={UrlConfig.home}
      />

      {NavigationDashboard.find((item) => item.to === UrlConfig.dashboard.dashboardBroker.url)?.isView && (
        <AsideMenuLeft
          icon={<BarChartIcon sx={{ color: colorPrimary }} />}
          title="Dashboard corretora"
          to={UrlConfig.dashboard.dashboardBroker.url}
          isProducer={isProducer}
        />
      )}

      <BaseMenuAside
        Navigation={NavigationControleEmpresa}
        icon={<AssuredWorkloadOutlinedIcon sx={{ color: colorPrimary }} />}
        open={open4}
        setOpen={setOpen4}
        title={UrlConfig.controle.title}
      />
      <BaseMenuAside
        Navigation={NavigationUsuarios}
        icon={<SupervisedUserCircleIcon sx={{ color: colorPrimary }} />}
        open={open3}
        setOpen={setOpen3}
        title={UrlConfig.usuarios.title}
      />
      <BaseMenuAside
        Navigation={NavigationProdutores}
        icon={<SensorOccupiedIcon sx={{ color: colorPrimary }} />}
        open={open1}
        setOpen={setOpen1}
        title={UrlConfig.produtores.title}
      />
      <BaseMenuAside
        Navigation={NavigationComissoes}
        icon={<PercentIcon sx={{ color: colorPrimary }} />}
        open={open5}
        setOpen={setOpen5}
        title={UrlConfig.comissao.title}
      />

      {NavigationLancamentos.find(
        (item) => item.to === UrlConfig.lancamentos.contratos.url
      )?.isView && (
          <AsideMenuLeft
            icon={<FileOpenIcon sx={{ color: colorPrimary }} />}
            title="Contratos"
            to={UrlConfig.lancamentos.contratos.url}
            isProducer={isProducer}
          />
        )}

      {NavigationLancamentos.find(
        (item) => item.to === UrlConfig.lancamentos.parcelas.url
      )?.isView && (
          <AsideMenuLeft
            icon={<AutoAwesomeMosaicIcon sx={{ color: colorPrimary }} />}
            title="Parcelas"
            to={UrlConfig.lancamentos.parcelas.url}
            isProducer={isProducer}
          />
        )}

      <AsideMenuLeft
        icon={<FileDownloadIcon sx={{ color: colorPrimary }} />}
        title="Baixar parcelas"
        to={UrlConfig.lancamentos.importInstallments.url}
        isProducer={isProducer}
        isFuture={true}
      />

      {NavigationPagamentos.find((item) => item.isView) && (
        <AsideMenuLeft
          icon={<AttachMoneyIcon sx={{ color: colorPrimary }} />}
          title="Gerar pagamento"
          to={UrlConfig.pagamentos.recibos.url}
          isProducer={isProducer}
        />
      )}

      <BaseMenuAside
        Navigation={NavigationRelations}
        icon={<DescriptionIcon sx={{ color: colorPrimary }} />}
        open={open8}
        setOpen={setOpen8}
        title="Relatórios produção"
      />
      <BaseMenuAside
        Navigation={NavigationReportsInstallments}
        icon={<DescriptionIcon sx={{ color: colorPrimary }} />}
        open={open9}
        setOpen={setOpen9}
        title="Relatórios parcelas"
      />
      <BaseMenuAside
        Navigation={NavigationAniversariantes}
        icon={<DescriptionIcon sx={{ color: colorPrimary }} />}
        open={open10}
        setOpen={setOpen10}
        title="Rel. aniversariantes"
      />
    </>
  );
};
